import React from 'react';
import { useSelector } from 'react-redux';

const SessionProgress = () => {
  const { sessionTarget, team1SessionScore, team2SessionScore, sessionOver, sessionWinner } = useSelector(
    (state) => state.gameSession
  );

  if (sessionOver) {
    return (
      <div className="text-center mb-3">
        <h4>🏆 Session Winner: <span className="text-primary">{sessionWinner}</span></h4>
        <p className="mb-0">Final score: {team1SessionScore} - {team2SessionScore} (first to {sessionTarget})</p>
      </div>
    );
  }

  return (
    <div className="text-center mb-3">
      <h5 className="mb-0">Session progress: {team1SessionScore} - {team2SessionScore}</h5>
      <small className="text-muted">First to {sessionTarget} wins the session</small>
    </div>
  );
};

export default SessionProgress;
